/**
 * The tenant's own daily/monthly spend limit was crossed — not a lack of money. The
 * wallet is still debited (always-charge); further calls are refused pre-call until
 * the window rolls.
 */

import type { TenantEventDefinition } from './definition'

export const BILLING_SPENDING_CAP_EVENT_TYPE = 'billing_spending_cap_reached' as const

export type SpendingCapScope = 'daily' | 'monthly'

export interface BillingSpendingCapPayload {
  scope: SpendingCapScope
  /** The cap that was crossed, in microUSD. */
  capMicrousd: number
  /** Spend in the current cap window, in microUSD. */
  spentMicrousd: number
}

function isSpendingCapPayload(payload: unknown): payload is BillingSpendingCapPayload {
  if (typeof payload !== 'object' || payload === null) return false
  const p = payload as Record<string, unknown>
  return (
    (p.scope === 'daily' || p.scope === 'monthly') &&
    typeof p.capMicrousd === 'number' &&
    Number.isFinite(p.capMicrousd) &&
    typeof p.spentMicrousd === 'number' &&
    Number.isFinite(p.spentMicrousd)
  )
}

export const billingSpendingCapEventDefinition: TenantEventDefinition<BillingSpendingCapPayload> =
  {
    eventType: BILLING_SPENDING_CAP_EVENT_TYPE,
    supportedChannelTypes: ['email', 'telegram'],
    validatePayload: isSpendingCapPayload,
    tenant: {
      label: 'Spending limit reached',
      description: "Spending reached the tenant's daily or monthly limit, so AI features stopped until it resets.",
      recipients: 'account_alerts',
      mandatory: false,
    },
  }
